<!-- src/app/pages/visitor-analytics/visitor-analytics.component.html -->

<div class="visitor-analytics-page">
  <div class="va-header">
    <div>
      <div class="va-eyebrow">Analytics</div>
      <h1>Visitantes web</h1>
      <p>
        Control básico de visitantes nuevos, recurrentes, actividad reciente y rutas más consultadas.
      </p>
    </div>

    <div class="va-filters">
      <label>
        Desde
        <input type="date" [(ngModel)]="from" />
      </label>

      <label>
        Hasta
        <input type="date" [(ngModel)]="to" />
      </label>

      <button type="button" class="va-btn" (click)="refresh()" [disabled]="loading">
        {{ loading ? 'Cargando...' : 'Actualizar' }}
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="va-alert">
    {{ errorMessage }}
  </div>

  <div class="va-loading" *ngIf="loading && !summary">
    Cargando analítica...
  </div>

  <ng-container *ngIf="summary">
    <section class="va-kpis">
      <article class="va-kpi va-kpi-total">
        <div class="va-kpi-icon">👁</div>
        <div>
          <span>Total visitantes</span>
          <strong>{{ formatNumber(summary.totalVisitors) }}</strong>
          <small>Histórico acumulado</small>
        </div>
      </article>

      <article class="va-kpi va-kpi-active">
        <div class="va-kpi-icon">🟢</div>
        <div>
          <span>Activos en rango</span>
          <strong>{{ formatNumber(summary.activeVisitorsInRange) }}</strong>
          <small>{{ from }} - {{ to }}</small>
        </div>
      </article>

      <article class="va-kpi va-kpi-new">
        <div class="va-kpi-icon">✨</div>
        <div>
          <span>Nuevos</span>
          <strong>{{ formatNumber(summary.newVisitors) }}</strong>
          <small>{{ formatPercent(summary.newVisitorRate) }} del rango</small>
        </div>
      </article>

      <article class="va-kpi va-kpi-returning">
        <div class="va-kpi-icon">↩</div>
        <div>
          <span>Recurrentes</span>
          <strong>{{ formatNumber(summary.returningVisitors) }}</strong>
          <small>{{ formatPercent(summary.returningRate) }} del rango</small>
        </div>
      </article>

      <article class="va-kpi va-kpi-requests">
        <div class="va-kpi-icon">⚡</div>
        <div>
          <span>Requests</span>
          <strong>{{ formatNumber(summary.totalRequests) }}</strong>
          <small>Peticiones de visitantes activos</small>
        </div>
      </article>
    </section>

    <section class="va-grid-main">
      <article class="va-card va-chart-card">
        <div class="va-card-header">
          <div>
            <h2>Evolución de visitantes</h2>
            <p>Nuevos, recurrentes y activos por día.</p>
          </div>
        </div>

        <div class="va-bars" *ngIf="timeline.length; else emptyTimeline">
          <div class="va-bar-item" *ngFor="let item of timeline">
            <div class="va-bar-tooltip">
              <strong>{{ item.date }}</strong>
              <span>Activos: {{ formatNumber(item.activeVisitors) }}</span>
              <span>Nuevos: {{ formatNumber(item.newVisitors) }}</span>
              <span>Recurrentes: {{ formatNumber(item.returningVisitors) }}</span>
            </div>

            <div
              class="va-bar va-bar-active"
              [style.height.%]="getTimelineHeight(item.activeVisitors)"
            ></div>

            <span>{{ formatShortDate(item.date) }}</span>
          </div>
        </div>

        <ng-template #emptyTimeline>
          <div class="va-empty">No hay datos para este rango.</div>
        </ng-template>
      </article>

      <article class="va-card va-active-card">
        <div class="va-card-header">
          <div>
            <h2>Activos ahora</h2>
            <p>Últimos {{ activeNow?.minutes || 10 }} minutos.</p>
          </div>

          <span class="va-live-pill">
            {{ activeNow?.count || 0 }} online
          </span>
        </div>

        <div class="va-active-list" *ngIf="activeNow?.items?.length; else emptyActive">
          <button
            type="button"
            class="va-active-item va-clickable-card"
            *ngFor="let visitor of activeNow?.items"
            (click)="openVisitorTrace(visitor)"
          >
            <div>
              <strong>{{ visitor.visitorId }}</strong>
              <span>{{ getPathLabel(visitor.lastPath, visitor.lastTitle) }}</span>
            </div>
            <small>{{ formatDate(visitor.lastSeenAt) }}</small>
          </button>
        </div>

        <ng-template #emptyActive>
          <div class="va-empty">No hay visitantes activos ahora.</div>
        </ng-template>
      </article>
    </section>

    <section class="va-grid-secondary">
      <article class="va-card">
        <div class="va-card-header">
          <div>
            <h2>Top rutas API</h2>
            <p>Última ruta registrada por visitante.</p>
          </div>
        </div>

        <div class="va-path-list" *ngIf="topPaths.length; else emptyPaths">
          <div class="va-path-item" *ngFor="let item of topPaths">
            <div class="va-path-top">
              <strong [title]="item.path">{{ cleanPath(item.path) }}</strong>
              <span>{{ formatPercent(item.percentage) }}</span>
            </div>

            <div class="va-progress">
              <div [style.width.%]="getPathWidth(item)"></div>
            </div>

            <div class="va-path-meta">
              <span>{{ formatNumber(item.visitors) }} visitantes</span>
              <span>{{ formatNumber(item.requests) }} requests</span>
            </div>
          </div>
        </div>

        <ng-template #emptyPaths>
          <div class="va-empty">No hay rutas registradas.</div>
        </ng-template>
      </article>

      <article class="va-card">
        <div class="va-card-header">
          <div>
            <h2>Últimos visitantes</h2>
            <p>Actividad reciente identificada por navegador.</p>
          </div>
        </div>

        <div class="va-table-wrap" *ngIf="recentVisitors.length; else emptyRecent">
          <table class="va-table">
            <thead>
              <tr>
                <th>Visitante</th>
                <th>Tipo</th>
                <th>Requests</th>
                <th>Última ruta</th>
                <th>Última actividad</th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="let visitor of recentVisitors"
                class="va-row-clickable"
                (click)="openVisitorTrace(visitor)"
              >
                <td>
                  <span class="va-visitor-id" [title]="visitor.visitorId">
                    {{ visitor.visitorId }}
                  </span>
                </td>

                <td>
                  <span class="va-badge" [ngClass]="getVisitorClass(visitor)">
                    {{ getVisitorLabel(visitor) }}
                  </span>
                </td>

                <td>{{ formatNumber(visitor.requestsCount) }}</td>

                <td>
                  <span [title]="visitor.lastPath">
                    {{ cleanPath(visitor.lastPath) }}
                  </span>
                </td>

                <td>{{ formatDate(visitor.lastSeenAt) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #emptyRecent>
          <div class="va-empty">Todavía no hay visitantes registrados.</div>
        </ng-template>
      </article>
    </section>

    <section class="va-card va-visitor-explorer">
      <div class="va-card-header va-explorer-header">
        <div>
          <h2>Explorador de visitantes</h2>
          <p>
            Busca un visitorId o una ruta concreta. Ejemplo:
            <strong>/dashboard-add-property</strong>
          </p>
        </div>

        <div class="va-search-box">
          <input
            type="text"
            [(ngModel)]="visitorSearchTerm"
            placeholder="Buscar visitorId o ruta: /dashboard-add-property"
            (ngModelChange)="onVisitorSearchTermChange()"
            (keyup.enter)="searchVisitorTrace()"
          />

          <button
            type="button"
            class="va-btn va-btn-small"
            (click)="searchVisitorTrace()"
            [disabled]="traceLoading || pageSearchLoading"
          >
            {{ pageSearchLoading ? 'Buscando...' : 'Buscar' }}
          </button>

          <button
            type="button"
            class="va-btn va-btn-small"
            *ngIf="visitorSearchTerm"
            (click)="clearVisitorSearch()"
            [disabled]="traceLoading || pageSearchLoading"
          >
            Limpiar
          </button>
        </div>
      </div>

      <div class="va-page-search-result" *ngIf="pageSearchActive">
        <strong>
          Navegaciones que incluyeron:
          {{ pageSearchLabel }}
        </strong>

        <span>
          {{ formatNumber(pageSearchResults.length) }} visitantes encontrados
        </span>
      </div>

      <div class="va-loading" *ngIf="pageSearchLoading">
        Buscando navegaciones por página...
      </div>

      <div class="va-alert" *ngIf="pageSearchError && !pageSearchLoading">
        {{ pageSearchError }}
      </div>

      <div class="va-alert" *ngIf="traceError && !traceModalOpen && !pageSearchLoading">
        {{ traceError }}
      </div>

      <div class="va-visitor-chips" *ngIf="getFilteredVisitors().length; else emptyExplorer">
        <button
          type="button"
          class="va-visitor-chip"
          *ngFor="let visitor of getFilteredVisitors(); trackBy: trackByVisitorId"
          (click)="openVisitorTrace(visitor)"
        >
          <strong [title]="visitor.visitorId">
            {{ visitor.visitorId || 'unknown' }}
          </strong>

          <span>
            {{ getVisitorLabel(visitor) }} ·
            {{ formatNumber(getExplorerRequests(visitor)) }}
            {{ pageSearchActive ? 'coincidencias' : 'req' }} ·
            {{ cleanPath(getExplorerPath(visitor)) }}
          </span>

          <small>
            {{ visitor.source || 'direct' }} ·
            {{ visitor.device || '-' }} ·
            {{ formatDate(getExplorerDate(visitor)) }}
          </small>

          <small *ngIf="pageSearchActive">
            Primera coincidencia:
            {{ formatDate($any(visitor).firstMatchedAt) }}
          </small>
        </button>
      </div>

      <ng-template #emptyExplorer>
        <div class="va-empty" *ngIf="!pageSearchLoading">
          No hay visitantes para mostrar en este rango.
        </div>
      </ng-template>
    </section>

    <section class="va-card va-behavior-insights" *ngIf="behaviorInsights">
      <div class="va-card-header">
        <div>
          <h2>Comportamiento de navegación</h2>
          <p>
            Dónde abandonan, dónde pasan más tiempo y qué sesiones tuvieron más interés.
          </p>
        </div>
      </div>

      <section class="va-kpis va-behavior-kpis">
        <article class="va-kpi">
          <div class="va-kpi-icon">🚪</div>
          <div>
            <span>Rebote</span>
            <strong>{{ formatPercent(getBehaviorSummary().bounceRate) }}</strong>
            <small>
              {{ formatNumber(getBehaviorSummary().bouncedSessions) }}
              sesiones sin navegación
            </small>
          </div>
        </article>

        <article class="va-kpi">
          <div class="va-kpi-icon">🧭</div>
          <div>
            <span>Sesiones</span>
            <strong>{{ formatNumber(getBehaviorSummary().totalSessions) }}</strong>
            <small>
              {{ formatNumber(getBehaviorSummary().totalPageviews) }} pageviews
            </small>
          </div>
        </article>

        <article class="va-kpi">
          <div class="va-kpi-icon">📄</div>
          <div>
            <span>Páginas / sesión</span>
            <strong>{{ getBehaviorSummary().averagePagesPerSession || 0 }}</strong>
            <small>Promedio de navegación</small>
          </div>
        </article>

        <article class="va-kpi">
          <div class="va-kpi-icon">⏱</div>
          <div>
            <span>Tiempo medio</span>
            <strong>{{ getBehaviorSummary().averageEstimatedSessionLabel || '0s' }}</strong>
            <small>Tiempo estimado por sesión</small>
          </div>
        </article>
      </section>

      <section class="va-behavior-grid">
        <article class="va-insight-card">
          <div class="va-card-header">
            <div>
              <h3>Dónde abandonan</h3>
              <p>Última página registrada en cada sesión.</p>
            </div>
          </div>

          <div class="va-chart-list" *ngIf="getExitsByPath().length; else emptyExits">
            <div class="va-chart-row" *ngFor="let item of getExitsByPath()">
              <div class="va-chart-row-top">
                <strong [title]="item.path">{{ cleanPath(item.path) }}</strong>
                <span>{{ formatNumber(item.exits) }} salidas</span>
              </div>

              <div class="va-chart-bar">
                <div [style.width.%]="getBarWidth(item, 'exits', getExitsByPath())"></div>
              </div>

              <div class="va-chart-meta">
                <span>Rebote salida: {{ formatPercent(item.bounceOnExitRate) }}</span>
                <span>Tiempo medio sesión: {{ item.averageSessionLabel }}</span>
              </div>
            </div>
          </div>

          <ng-template #emptyExits>
            <div class="va-empty">No hay datos de abandono.</div>
          </ng-template>
        </article>

        <article class="va-insight-card">
          <div class="va-card-header">
            <div>
              <h3>Dónde pasan más tiempo</h3>
              <p>Tiempo estimado entre una página y la siguiente.</p>
            </div>
          </div>

          <div class="va-chart-list" *ngIf="getTimeByPath().length; else emptyTime">
            <div class="va-chart-row" *ngFor="let item of getTimeByPath()">
              <div class="va-chart-row-top">
                <strong [title]="item.path">{{ cleanPath(item.path) }}</strong>
                <span>{{ item.averageLabel }}</span>
              </div>

              <div class="va-chart-bar">
                <div [style.width.%]="getBarWidth(item, 'averageSeconds', getTimeByPath())"></div>
              </div>

              <div class="va-chart-meta">
                <span>{{ formatNumber(item.views) }} vistas</span>
                <span>Salida: {{ formatPercent(item.exitRate) }}</span>
              </div>
            </div>
          </div>

          <ng-template #emptyTime>
            <div class="va-empty">No hay datos de tiempo por página.</div>
          </ng-template>
        </article>
      </section>

      <section class="va-behavior-grid">
        <article class="va-insight-card">
          <div class="va-card-header">
            <div>
              <h3>Entradas principales</h3>
              <p>Primera página de cada sesión.</p>
            </div>
          </div>

          <div class="va-chart-list" *ngIf="getEntryPages().length; else emptyEntries">
            <div class="va-chart-row" *ngFor="let item of getEntryPages()">
              <div class="va-chart-row-top">
                <strong [title]="item.path">{{ cleanPath(item.path) }}</strong>
                <span>{{ formatNumber(item.entries) }} entradas</span>
              </div>

              <div class="va-chart-bar">
                <div [style.width.%]="getBarWidth(item, 'entries', getEntryPages())"></div>
              </div>

              <div class="va-chart-meta">
                <span>Rebote: {{ formatPercent(item.bounceRate) }}</span>
              </div>
            </div>
          </div>

          <ng-template #emptyEntries>
            <div class="va-empty">No hay entradas registradas.</div>
          </ng-template>
        </article>

        <article class="va-insight-card">
          <div class="va-card-header">
            <div>
              <h3>Calidad por fuente</h3>
              <p>Qué tráfico navega mejor.</p>
            </div>
          </div>

          <div class="va-table-wrap" *ngIf="getSourceQuality().length; else emptySources">
            <table class="va-table">
              <thead>
                <tr>
                  <th>Fuente</th>
                  <th>Sesiones</th>
                  <th>Rebote</th>
                  <th>Pág/sesión</th>
                  <th>Tiempo</th>
                  <th>Relevantes</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of getSourceQuality()">
                  <td>
                    <span class="va-source-pill">
                      {{ item.source || 'direct' }}
                    </span>
                  </td>
                  <td>{{ formatNumber(item.sessions) }}</td>
                  <td>{{ formatPercent(item.bounceRate) }}</td>
                  <td>{{ item.averagePagesPerSession }}</td>
                  <td>{{ item.averageEstimatedLabel }}</td>
                  <td>
                    {{ formatNumber(item.relevantSessions) }}
                    <small>({{ formatPercent(item.relevanceRate) }})</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #emptySources>
            <div class="va-empty">No hay fuentes para analizar.</div>
          </ng-template>
        </article>
      </section>

      <section class="va-insight-card">
        <div class="va-card-header">
          <div>
            <h3>Visitas más relevantes</h3>
            <p>Sesiones con más navegación, más tiempo o rutas importantes.</p>
          </div>
        </div>

        <div class="va-table-wrap" *ngIf="getRelevantSessions().length; else emptyRelevant">
          <table class="va-table">
            <thead>
              <tr>
                <th>Visitante</th>
                <th>Fuente</th>
                <th>Páginas</th>
                <th>Tiempo</th>
                <th>Entrada</th>
                <th>Salida</th>
                <th>Score</th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="let session of getRelevantSessions()"
                class="va-row-clickable"
                (click)="openRelevantSessionTrace(session)"
              >
                <td>
                  <span class="va-visitor-id" [title]="session.visitorKey">
                    {{ session.visitorId || 'unknown' }}
                  </span>
                </td>

                <td>
                  <span class="va-source-pill">
                    {{ session.source || 'direct' }}
                  </span>
                </td>

                <td>
                  {{ formatNumber(session.totalPageviews) }}
                  <small>{{ session.uniquePathsCount }} únicas</small>
                </td>

                <td>{{ session.estimatedDurationLabel }}</td>

                <td>
                  <span [title]="session.entryPath">
                    {{ cleanPath(session.entryPath) }}
                  </span>
                </td>

                <td>
                  <span [title]="session.exitPath">
                    {{ cleanPath(session.exitPath) }}
                  </span>
                </td>

                <td>
                  <strong>{{ session.relevanceScore }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #emptyRelevant>
          <div class="va-empty">No hay sesiones relevantes todavía.</div>
        </ng-template>
      </section>

      <section class="va-insight-card">
        <div class="va-card-header">
          <div>
            <h3>Rutas más repetidas</h3>
            <p>Secuencias de navegación más comunes.</p>
          </div>
        </div>

        <div class="va-chart-list" *ngIf="getJourneys().length; else emptyJourneys">
          <div class="va-chart-row" *ngFor="let item of getJourneys()">
            <div class="va-chart-row-top">
              <strong [title]="item.journey">
                {{ cleanLongText(item.journey, 120) }}
              </strong>
              <span>{{ formatNumber(item.count) }} veces</span>
            </div>

            <div class="va-chart-bar">
              <div [style.width.%]="getBarWidth(item, 'count', getJourneys())"></div>
            </div>
          </div>
        </div>

        <ng-template #emptyJourneys>
          <div class="va-empty">No hay rutas repetidas todavía.</div>
        </ng-template>
      </section>
    </section>
  </ng-container>

  <div
    class="va-modal-backdrop"
    *ngIf="traceModalOpen"
    (click)="closeTraceModal()"
  >
    <section class="va-modal" (click)="$event.stopPropagation()">
      <div class="va-modal-header">
        <div>
          <span class="va-eyebrow">Visitor trace</span>
          <h2>Traza de navegación</h2>
          <p *ngIf="selectedTrace?.visitorId">
            {{ selectedTrace?.visitorId }}
          </p>
        </div>

        <button type="button" class="va-modal-close" (click)="closeTraceModal()">
          ×
        </button>
      </div>

      <div class="va-loading" *ngIf="traceLoading">
        Cargando traza de navegación...
      </div>

      <div class="va-alert" *ngIf="traceError && !traceLoading">
        {{ traceError }}
      </div>

      <ng-container *ngIf="selectedTrace && !traceLoading">
        <div class="va-trace-summary">
          <article>
            <span>Pageviews</span>
            <strong>{{ formatNumber(selectedTrace.summary.totalPageviews) }}</strong>
          </article>

          <article>
            <span>Sesiones</span>
            <strong>{{ formatNumber(selectedTrace.summary.totalSessions) }}</strong>
          </article>

          <article>
            <span>Duración estimada</span>
            <strong>{{ selectedTrace.summary.durationEstimatedLabel }}</strong>
          </article>

          <article>
            <span>Duración bruta</span>
            <strong>{{ selectedTrace.summary.rawDurationLabel }}</strong>
          </article>
        </div>

        <div class="va-trace-meta">
          <div>
            <span>Entrada</span>
            <strong>{{ cleanPath(selectedTrace.summary.entryRoute) }}</strong>
            <small>{{ formatDate(selectedTrace.summary.entryTime) }}</small>
          </div>

          <div>
            <span>Salida</span>
            <strong>{{ cleanPath(selectedTrace.summary.exitRoute) }}</strong>
            <small>{{ formatDate(selectedTrace.summary.exitTime) }}</small>
          </div>

          <div>
            <span>Source inicial</span>
            <strong>{{ selectedTrace.summary.firstSource || '-' }}</strong>
            <small>{{ cleanLongText(selectedTrace.summary.firstReferrer, 90) }}</small>
          </div>

          <div>
            <span>Dispositivo</span>
            <strong>{{ selectedTrace.summary.firstDevice || '-' }}</strong>
            <small>{{ selectedTrace.summary.uniqueRoutesCount }} rutas únicas</small>
          </div>
        </div>

        <div class="va-trace-sessions" *ngIf="selectedTrace.sessions?.length">
          <h3>Sesiones</h3>

          <div class="va-session-card" *ngFor="let session of selectedTrace.sessions">
            <div>
              <strong>Sesión {{ session.sessionNumber }}</strong>
              <span>
                {{ cleanPath(session.entryRoute) }} → {{ cleanPath(session.exitRoute) }}
              </span>
            </div>

            <small>
              {{ formatDate(session.entryTime) }} ·
              {{ session.totalPageviews }} páginas ·
              {{ session.durationEstimatedLabel }}
            </small>
          </div>
        </div>

        <div class="va-table-wrap va-trace-table-wrap">
          <table class="va-table va-trace-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Ruta</th>
                <th>Hora de entrada</th>
                <th>Referrer</th>
                <th>Source</th>
                <th>Dispositivo</th>
                <th>Tiempo hasta siguiente</th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="let item of selectedTrace.sequence; trackBy: trackByTraceStep"
                [class.va-session-start]="item.startsNewSession"
              >
                <td>{{ item.order }}</td>

                <td>
                  <strong [title]="item.fullUrl">{{ cleanPath(item.route) }}</strong>
                  <small>{{ cleanLongText(item.title, 70) }}</small>
                </td>

                <td>{{ formatDate(item.entryTime) }}</td>

                <td>
                  <span [title]="item.referrer">
                    {{ cleanLongText(item.referrer, 60) }}
                  </span>
                </td>

                <td>
                  <span class="va-source-pill">
                    {{ item.source || '-' }}
                  </span>
                </td>

                <td>{{ item.device || '-' }}</td>

                <td>
                  <strong>{{ item.timeToNextLabel || '-' }}</strong>
                  <small
                    *ngIf="item.rawTimeToNextLabel && item.rawTimeToNextLabel !== item.timeToNextLabel"
                  >
                    real: {{ item.rawTimeToNextLabel }}
                  </small>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </section>
  </div>
</div>